<form 
    (ngSubmit)="$event.preventDefault(); saveRmsPlanCompletion();"
    [formGroup]="planCompletionForm"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
>
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            RMS Plan Completion
        </h2>
        <!-- <p class="font-semibold">
            For each item checked, please include specific information in the Record of Assigned Responsibilities (ROAR) portion regarding what steps will be taken, who is responsible, and the time frame for completion.
        </p> -->
        <div class="w-full flex flex-col items-center gap-2 pb-4"> 

            <div class="w-full flex flex-col items-start text-start">
                <div class="w-full font-semibold">
                    <p>The Threat Assessment Team for this case certifies that this Response, Management, and Support Plan is complete and has been developed to respond to and manage the threat and to support the student of concern. *</p>
                </div>
                <div class="w-full flex items-start gap-2">
                    <div>
                        <input type="radio" id="certification_yes" value="{{ yesNo.Yes }}" class="hidden peer"
                            formControlName="certification"
                        >
                        <label for="certification_yes"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            True
                        </label>
                    </div>
                    <div>
                        <input type="radio" id="certification_no" value="{{ yesNo.No }}" class="hidden peer"
                            formControlName="certification"
                        >
                        <label for="certification_no"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            False
                        </label>
                    </div>
                </div>
            </div>
            <div class="w-full flex flex-col gap-2">
                <div class="w-full font-semibold">
                    <p>Please record any additional notes or instructions needed for the implementation of this RMS Plan: *</p>
                </div>
                <div class="w-full flex flex-col items-center">
                    <textarea 
                        formControlName="rms_plan_notes"
                        rows="3"
                        class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                        placeholder="Type here..."></textarea>
                </div>
            </div>
            
            
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.planCompletionForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.planCompletionForm.valid
                }"
                [disabled]="this.planCompletionForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>